import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, NgModule } from '@angular/core';
import * as i1$1 from '@upr-web-primer/page-labels';
import * as i1 from '@upr-web-primer/storage';
import { Subject } from 'rxjs';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = (a0, a1) => ({
  "background-color": a0,
  color: a1
});
function NotificationComponent_div_0_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 8);
  }
}
function NotificationComponent_div_0_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function NotificationComponent_div_0_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.closeCTAText, " ");
  }
}
function NotificationComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div");
    i0.ɵɵtemplate(3, NotificationComponent_div_0_i_3_Template, 1, 0, "i", 3);
    i0.ɵɵelement(4, "span", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, NotificationComponent_div_0_button_5_Template, 2, 1, "button", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6)(7, "button", 7);
    i0.ɵɵlistener("click", function NotificationComponent_div_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("row notification-msg ", ctx_r2.state, "");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(8, _c0, ctx_r2.bgColor, ctx_r2.color));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.state === "error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", ctx_r2.message, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.closeCTAText);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r2.txtCloseNotification);
  }
}
class NotificationService {
  constructor(sessionStorage) {
    this.sessionStorage = sessionStorage;
    this.notifications$ = new Subject();
  }
  show(message, state = 'error', bgColor, color, closeCTAText) {
    this.notifications$.next({
      show: true,
      state: state,
      message: message,
      bgColor: bgColor,
      color: color,
      closeCTAText: closeCTAText
    });
    if (!state || state === 'error') {
      this.sessionStorage.removeItem('RETAIN_NOTIFICATION');
    }
  }
  hide() {
    this.notifications$.next({
      show: false
    });
  }
  static {
    this.ɵfac = function NotificationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationService)(i0.ɵɵinject(i1.SessionStorageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NotificationService,
      factory: NotificationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.SessionStorageService
  }], null);
})();
class NotificationComponent {
  constructor(pageLabelsResolver, notifications) {
    this.pageLabelsResolver = pageLabelsResolver;
    this.notifications = notifications;
    this.closeClick = new EventEmitter();
    this.pageLabelsResolver.resolve().then(data => {
      this.txtCloseNotification = data?.txtCloseNotification || 'Close Notification';
    });
    this.notificationsSub = this.notifications.notifications$.subscribe(notification => {
      if (!notification) {
        return;
      }
      this.show = notification.show;
      this.state = notification.state || 'error';
      this.message = notification.message;
      this.bgColor = notification.bgColor;
      this.color = notification.color;
      this.closeCTAText = notification.closeCTAText;
    });
  }
  close() {
    this.show = false;
    if (this.closeClick) {
      this.closeClick.emit(this.state);
    }
  }
  open() {
    this.show = true;
  }
  ngOnDestroy() {
    this.notificationsSub.unsubscribe();
  }
  static {
    this.ɵfac = function NotificationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationComponent)(i0.ɵɵdirectiveInject(i1$1.PageLabelsResolver), i0.ɵɵdirectiveInject(NotificationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NotificationComponent,
      selectors: [["upr-notification"]],
      outputs: {
        closeClick: "closeClick"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["role", "alert", 3, "class", "ngStyle", 4, "ngIf"], ["role", "alert", 3, "ngStyle"], [1, "column", "small-offset-1"], ["class", "icon icon-alert", "aria-hidden", "true", 4, "ngIf"], [1, "notification-msg--text", 3, "innerHtml"], ["type", "button", "class", "close-cta", 3, "click", 4, "ngIf"], [1, "column", "small-1"], [1, "icon", "icon-close", "pointer", 3, "click"], ["aria-hidden", "true", 1, "icon", "icon-alert"], ["type", "button", 1, "close-cta", 3, "click"]],
      template: function NotificationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NotificationComponent_div_0_Template, 8, 11, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.show && ctx.message);
        }
      },
      dependencies: [i3.NgIf, i3.NgStyle],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.error[_ngcontent-%COMP%]{background-color:#e61b23;border-bottom:1px solid #e61b23}.success[_ngcontent-%COMP%]{background-color:#52a41d;border-bottom:1px solid #52a41d}.warning[_ngcontent-%COMP%]{background-color:#f7ca18;border-bottom:1px solid #f7ca18}.pointer[_ngcontent-%COMP%]{cursor:pointer}.notification-msg[_ngcontent-%COMP%]{padding:14px;align-items:center;position:fixed;z-index:9999;color:#fff;text-align:center;font-size:20px;min-width:100%;min-height:100px;-webkit-animation:fadeInDown 1s ease .2s 1 both;-moz-animation:fadeInDown 1s ease .2s 1 both;animation:fadeInDown 1s ease .2s 1 both;-webkit-animation-backface-visibility:hidden;-moz-animation-backface-visibility:hidden;-ms-animation-backface-visibility:hidden;-o-animation-backface-visibility:hidden}.notification-msg.error[_ngcontent-%COMP%]   i.icon.icon-alert[_ngcontent-%COMP%]{position:relative;top:1px;padding-right:7px}.notification-msg[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#fff}.close-cta[_ngcontent-%COMP%]{display:inline-block;background-color:transparent;text-decoration:none;cursor:pointer;border:0;padding:0;color:#036ce2;font:inherit;font-weight:700}.white-background[_nghost-%COMP%], .white-background   [_nghost-%COMP%]{color:#0368d9}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationComponent, [{
    type: Component,
    args: [{
      selector: 'upr-notification',
      standalone: false,
      template: "<div\r\n\t*ngIf=\"show && message\"\r\n\tclass=\"row notification-msg {{ state }}\"\r\n\t[ngStyle]=\"{ 'background-color': bgColor, color: color }\"\r\n\trole=\"alert\"\r\n>\r\n\t<div class=\"column small-offset-1\">\r\n\t\t<div>\r\n\t\t\t<i\r\n\t\t\t\t*ngIf=\"state === 'error'\"\r\n\t\t\t\tclass=\"icon icon-alert\"\r\n\t\t\t\taria-hidden=\"true\"\r\n\t\t\t></i>\r\n\t\t\t<span class=\"notification-msg--text\" [innerHtml]=\"message\"></span>\r\n\t\t</div>\r\n\t\t<button\r\n\t\t\ttype=\"button\"\r\n\t\t\tclass=\"close-cta\"\r\n\t\t\t*ngIf=\"closeCTAText\"\r\n\t\t\t(click)=\"close()\"\r\n\t\t>\r\n\t\t\t{{ closeCTAText }}\r\n\t\t</button>\r\n\t</div>\r\n\t<div class=\"column small-1\">\r\n\t\t<button\r\n\t\t\tclass=\"icon icon-close pointer\"\r\n\t\t\t[attr.aria-label]=\"txtCloseNotification\"\r\n\t\t\t(click)=\"close()\"\r\n\t\t></button>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.error{background-color:#e61b23;border-bottom:1px solid #e61b23}.success{background-color:#52a41d;border-bottom:1px solid #52a41d}.warning{background-color:#f7ca18;border-bottom:1px solid #f7ca18}.pointer{cursor:pointer}.notification-msg{padding:14px;align-items:center;position:fixed;z-index:9999;color:#fff;text-align:center;font-size:20px;min-width:100%;min-height:100px;-webkit-animation:fadeInDown 1s ease .2s 1 both;-moz-animation:fadeInDown 1s ease .2s 1 both;animation:fadeInDown 1s ease .2s 1 both;-webkit-animation-backface-visibility:hidden;-moz-animation-backface-visibility:hidden;-ms-animation-backface-visibility:hidden;-o-animation-backface-visibility:hidden}.notification-msg.error i.icon.icon-alert{position:relative;top:1px;padding-right:7px}.notification-msg button{color:#fff}.close-cta{display:inline-block;background-color:transparent;text-decoration:none;cursor:pointer;border:0;padding:0;color:#036ce2;font:inherit;font-weight:700}:host-context(.white-background){color:#0368d9}\n"]
    }]
  }], () => [{
    type: i1$1.PageLabelsResolver
  }, {
    type: NotificationService
  }], {
    closeClick: [{
      type: Output
    }]
  });
})();
class NotificationModule {
  static {
    this.ɵfac = function NotificationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NotificationModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [NotificationComponent],
      exports: [NotificationComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of notification
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NotificationComponent, NotificationModule, NotificationService };
